import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import SVGImage from './Image/SVGImage'

interface AnswerBoxProps {
  answer?: string
  subject?: string
}

export const AnswerBox: FC<AnswerBoxProps> = ({ answer, subject = '' }) => {
  const { t } = useTranslation('ads')

  return (
    <div className="self-center lg:self-auto relative mb-4 lg:mb-11 lg:mt-40  drop-shadow-2xl border-solid border-4 box-border border-white z-30 rounded  w-60 md:w-adbox">
      <SVGImage alt={t('cloud')} imageClassName="absolute top-4 md:top-2 md:left-12" srcKey="misc/cloud.svg" />
      <h3 className="relative font-bold text-sm md:text-h3 h-9 my-7 md:mt-11 ml-2 md:ml-4 z-20 mb-4 flex justify-start ">
        {t('header')}
        <div className=" rounded gradient-border-container h-8 md:h-12 z-20 ml-1 md:ml-3 w-8 md:w-12">
          <div className="bg-blue-light h-full text-center  ">{answer}</div>
        </div>
      </h3>
      <div className="relative mb-3 ml-5 text-xs">{t('learnMore', { subject: t(subject) })}</div>
    </div>
  )
}
